import { apiRoutes } from '@/config/api-routes'
import { usersApi } from '@/lib/axios'

export async function updateUser(id: number, name: string) {
  return usersApi.put(`${apiRoutes.updateUser}/${id}`, { name })
}
